import type {KpPdfViewerComponentController} from '../kp-pdf-viewer/kp-pdf-viewer.component';
import {PdfViewerDefaultProxy} from './pdf-viewer-default-proxy';
import type PdfProxiedCommands from './pdf-proxied-commands';

export default class PdfViewerProxy extends PdfViewerDefaultProxy<KpPdfViewerComponentController> implements PdfProxiedCommands {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public setPageCount(totalPages: number) {
        // eslint-disable-next-line no-console
        console.warn('This is only one-way command');
    }

    public setCurrentPage(currentPage: number) {
        this.call((controller) => controller.currentPage = currentPage);
    }

    public fitAuto() {
        this.call((controller) => controller.fit = 'auto');
    }

    public fitWidth() {
        this.call((controller) => controller.fit = 'width');
    }

    public updateScale(scale: number) {
        this.call((controller) => controller.updateScale(scale));
    }
}
